function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { useEffect, useRef } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { richTextValidation } from 'validators';
import { RichTextEditor, Typography } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import { useOnMount } from "../../../../hooks/useOnMount";
import { connectControllerToRichTextEditor } from "../../../../utils/react-hook-form.utils";
import { useRichTextVariableIntegration } from "../../TemplateVariables/hooks/useRichTextVariableIntegration";
import { VariableInsertButton } from "../../TemplateVariables/VariableInsertButton/VariableInsertButton";
import { VariablePickerPopover } from "../../TemplateVariables/VariablePickerPopover/VariablePickerPopover";
import styles from "./ExtraClause.module.scss";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export const GetExtraClauseTID = parentTestId => getTestIds(parentTestId);
export default function ExtraClause(_ref) {
  let {
    showAgreementSettingsWarning,
    isReadOnly,
    onValidation,
    hideLabel = false,
    onChange = () => {}
  } = _ref;
  const {
    control,
    formState,
    trigger
  } = useFormContext();
  const validation = richTextValidation('Notes');
  const editorElRef = useRef(null);
  const {
    enabled,
    toolbarButtonProps,
    pickerPopoverProps
  } = useRichTextVariableIntegration(editorElRef, {
    disabled: isReadOnly,
    testId: 'extra-clause',
    keyboardEnabled: !isReadOnly
  });
  useEffect(() => {
    onValidation(formState.isValid);
  }, [formState, onValidation]);
  useEffect(() => {
    if (showAgreementSettingsWarning) trigger('extraClause');
  }, [showAgreementSettingsWarning, trigger]);
  useOnMount(() => {
    trigger('extraClause');
  });
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [!hideLabel && /*#__PURE__*/_jsx(Typography, {
      style: {
        paddingBottom: '8px'
      },
      className: styles.text,
      children: "Add a note to your agreement (optional)"
    }), /*#__PURE__*/_jsx(Controller, {
      control: control,
      name: "extraClause",
      rules: validation,
      render: renderProps => {
        const connected = connectControllerToRichTextEditor(renderProps, {
          alwaysShowErrors: true
        });
        const originalEditorRef = connected.editorRef;
        return /*#__PURE__*/_jsx(RichTextEditor, _objectSpread(_objectSpread(_objectSpread({
          editorHeight: 200,
          placeholder: "Add here anything you need that's not specified elsewhere",
          isReadOnly: isReadOnly,
          testId: "formling-extra-clause-input"
        }, connected), validation.dataAttr), {}, {
          editorRef: el => {
            editorElRef.current = el;
            if (typeof originalEditorRef === 'function') {
              originalEditorRef(el);
            }
          },
          onChange: function (_onChange) {
            function onChange(_x) {
              return _onChange.apply(this, arguments);
            }
            onChange.toString = function () {
              return _onChange.toString();
            };
            return onChange;
          }(v => {
            onChange(v);
            connected.onChange(v);
          }),
          toolbarActions: enabled ? /*#__PURE__*/_jsx(VariableInsertButton, _objectSpread({}, toolbarButtonProps)) : null
        }));
      }
    }), enabled && /*#__PURE__*/_jsx(VariablePickerPopover, _objectSpread({}, pickerPopoverProps))]
  });
}